import ExcelJS from 'exceljs'

export function exportPerformance(data) {

    const workbook = new ExcelJS.Workbook()

    const worksheet =
        workbook.addWorksheet('业绩统计')

    // =====================
    // 冻结窗格
    // =====================

    worksheet.views = [
        {
            state: 'frozen',
            xSplit: 1,
            ySplit: 2
        }
    ]

    // =====================
    // 表头
    // =====================

    worksheet.mergeCells('A1:A2')

    worksheet.mergeCells('B1:C1')
    worksheet.mergeCells('D1:E1')
    worksheet.mergeCells('F1:G1')
    worksheet.mergeCells('H1:I1')
    worksheet.mergeCells('J1:K1')
    worksheet.mergeCells('L1:M1')
    worksheet.mergeCells('N1:O1')
    worksheet.mergeCells('P1:Q1')
    worksheet.mergeCells('R1:S1')

    worksheet.getCell('A1').value = '所属授权公司'

    worksheet.getCell('B1').value = '0业绩'
    worksheet.getCell('D1').value = '1万以下'
    worksheet.getCell('F1').value = '1-5万'
    worksheet.getCell('H1').value = '5-10万'
    worksheet.getCell('J1').value = '10-20万'
    worksheet.getCell('L1').value = '20-50万'
    worksheet.getCell('N1').value = '50-100万'
    worksheet.getCell('P1').value = '100万以上'
    worksheet.getCell('R1').value = '合计'

    worksheet.getCell('B2').value = '店数'
    worksheet.getCell('C2').value = '占比'

    worksheet.getCell('D2').value = '店数'
    worksheet.getCell('E2').value = '业绩'

    worksheet.getCell('F2').value = '店数'
    worksheet.getCell('G2').value = '业绩'

    worksheet.getCell('H2').value = '店数'
    worksheet.getCell('I2').value = '业绩'

    worksheet.getCell('J2').value = '店数'
    worksheet.getCell('K2').value = '业绩'

    worksheet.getCell('L2').value = '店数'
    worksheet.getCell('M2').value = '业绩'

    worksheet.getCell('N2').value = '店数'
    worksheet.getCell('O2').value = '业绩'

    worksheet.getCell('P2').value = '店数'
    worksheet.getCell('Q2').value = '业绩'

    worksheet.getCell('R2').value = '店数'
    worksheet.getCell('S2').value = '业绩'

    // =====================
    // 表头样式
    // =====================

    worksheet.getRow(1).height = 35
    worksheet.getRow(2).height = 28

    for (let row = 1; row <= 2; row++) {

        worksheet.getRow(row).eachCell(cell => {

            cell.font = {
                bold: true,
                color: {
                    argb: 'FFFFFF'
                },
                size: 12
            }

            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {
                    argb: 'C00000'
                }
            }

            cell.alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

        })

    }

    // =====================
    // 数据
    // =====================

    let rowIndex = 3

    data.forEach(item => {

        const row =
            worksheet.getRow(rowIndex)

        row.getCell(1).value =
            item.companyName

        row.getCell(2).value =
            item.zero.count

        row.getCell(3).value =
            item.zero.rate

        row.getCell(4).value =
            item.lt1.count

        row.getCell(5).value =
            item.lt1.amount

        row.getCell(6).value =
            item.r1_5.count

        row.getCell(7).value =
            item.r1_5.amount

        row.getCell(8).value =
            item.r5_10.count

        row.getCell(9).value =
            item.r5_10.amount

        row.getCell(10).value =
            item.r10_20.count

        row.getCell(11).value =
            item.r10_20.amount

        row.getCell(12).value =
            item.r20_50.count

        row.getCell(13).value =
            item.r20_50.amount

        row.getCell(14).value =
            item.r50_100.count

        row.getCell(15).value =
            item.r50_100.amount

        row.getCell(16).value =
            item.gt100.count

        row.getCell(17).value =
            item.gt100.amount

        row.getCell(18).value =
            item.total.count

        row.getCell(19).value =
            item.total.amount

        // 金额列千分位

        const moneyCols = [
            5, 7, 9, 11, 13,
            15, 17, 19
        ]

        moneyCols.forEach(col => {

            row.getCell(col).numFmt =
                '#,##0'

        })

        rowIndex++

    })

    // =====================
    // 列宽
    // =====================

    worksheet.getColumn(1).width = 25

    for(let i=2;i<=19;i++){

        worksheet.getColumn(i).width = 12

    }

    // =====================
    // 边框
    // =====================

    worksheet.eachRow(row => {

        row.eachCell(cell => {

            cell.border = {

                top: {
                    style: 'thin'
                },

                left: {
                    style: 'thin'
                },

                bottom: {
                    style: 'thin'
                },

                right: {
                    style: 'thin'
                }

            }

            cell.alignment = {

                horizontal: 'center',
                vertical: 'middle'

            }

        })

    })

    // =====================
    // 下载
    // =====================

    workbook.xlsx
        .writeBuffer()
        .then(buffer => {

            const blob = new Blob(
                [buffer],
                {
                    type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
            )

            const link =
                document.createElement('a')

            link.href =
                URL.createObjectURL(blob)

            link.download =
                '店面业绩区间表.xlsx'

            document.body.appendChild(link)

            link.click()

            document.body.removeChild(link)

            URL.revokeObjectURL(
                link.href
            )

        })

}